import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'Nameless',
    name: 'Seigneur de la Désolation',
    id: 'BlightLord',
    health: 70,
    difficulty: 4,
    additionalInfo: '',
    expeditionRating: 2,
  },
  {
    expansion: 'Nameless',
    name: "L'Egaré",
    id: 'WaywardOne',
    health: 60,
    difficulty: 7,
    additionalInfo: '',
    expeditionRating: 3,
  },
]
